import React from "react";
import PropTypes from "prop-types";
import RoleModalTable from "../table/all-tables/userrolemodaltable/RoleModalTable";
import { alertActions, roleMange } from "../../locales/en";
import CommonModal from "./CommonModal";
import ErrorBoundary from "../error-boundary";
import ModalFallback from "../error-boundary/fallback/ModalFallback";

const UserRoleListModal = ({ isOpen, toggle, roleId }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="modal-dialog modal-xl"
      title={roleMange.userListModal.title}
      footerButtons={[
        {
          label: alertActions.Cancel,
          className: "btn btn-secondary",
          onClick: () => toggle(false)
        }
      ]}
    >
      <ErrorBoundary fallback={<ModalFallback />}>
        <div className="row">
          <div className="col-12">
            <RoleModalTable roleId={roleId} />
          </div>
        </div>
      </ErrorBoundary>
    </CommonModal>
  );
};

UserRoleListModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  roleId: PropTypes.any
};
export default UserRoleListModal;
